import { ApiResult, ApprovalGroup } from "./types";

const formatTitle = (key: string): string =>
  key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();

export const transformApiToGroups = (result?: ApiResult): ApprovalGroup[] => {
  const normalizedResult = result ?? {};
  return Object.entries(normalizedResult)
    .filter(([, items]) => Array.isArray(items) && items.length > 0)
    .map(([key, items], groupIndex) => ({
      id: `group-${groupIndex + 1}`,

      title: formatTitle(key),
      count: items.length, // ✅ group count
      items: items.map((item, itemIndex) => ({
        id: `${groupIndex + 1}-${itemIndex + 1}`,
        unitDetails: item.unitDetail,
        tenantName: item.tenantName,
        requestedBy: item.requestedBy,
        date: item.requestDate,
        titleKey: key,
        leaseId: item.leaseId,
        pdcId: item.pdcId,
        paymentReceiptId: item.paymentReceiptId,
      })),
    }));
};
